export const VIBES = ['Antique', 'Art Deco', 'Contemporary', 'Industrial', 'Mid Century Modern',
  'Modern', 'Vintage', 'Oriental', 'Postmodern', 'Shabby Chic', 'Rustic', 'Hollywood Regency', 'Retro', 'Scandinavian Modern']
